<template>
  <div :class="$style.main">
    <div :class="$style.mainHeader">
      <MobileIconButton :class="$style.userButton"
                        symbol="account-icon"
                        icon-size="24"
                        icon-fill="#808080"
                        @click="userButtonAction"/>
    </div>

    <div>
      <img :class="$style.mainLogo"
           srcset="@/assets/img/LOGO@2x.png, @/assets/img/LOGO.png"
           src="@/assets/img/LOGO.png"
           alt="Burger Boss">

      <p v-if="user"
         :class="$style.welcomText">
        Welcome Back, {{ user.firstName | capitalize }}!
      </p>
      <template v-else>
        <hr :class="$style.hr">

        <p :class="$style.text">
          Entered a phone number
          at one of our kiosks?

          <router-link :class="$style.link"
                       :to="{ name: 'claim-account' }">
            Claim Your Account
          </router-link>
        </p>
      </template>
    </div>

    <div :class="$style.btnGroup">
      <MobileButton @click.native="newOrder">
        New Order
      </MobileButton>
      <MobileButton :disabled="!user"
                    :to="{ name: 'past-order-select-location' }">
        Past Orders
        <template slot="sub">
          Quickly Re-Order
        </template>
      </MobileButton>
      <MobileButton
        btn-style="border"
        @click.native="goToLocations">
        Locations
      </MobileButton>
    </div>

    <div v-if="user"
         :class="$style.tryOur">
      <div :class="$style.tryOurContent">
        <h5 :class="$style.tryOurTitle">
          Try Our
        </h5>
        <p :class="$style.tryOurText">
          Vegan black bean patty
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import MobileButton from '@/apps/mobile/components/MobileButton';
import { Getter } from 'vuex-class';
import MobileIconButton from '@/apps/mobile/components/MobileIconButton';

/**
 * Mobile main page.
 */
@Component({
  components: {
    MobileButton,
    MobileIconButton,
  },
})
export default class MobileMain extends Vue {
  @Getter('authUser') user;
  @Getter restaurantId;

  goToLocations() {
    this.$router.push({ name: 'locations' });
  }

  userButtonAction() {
    const name = this.user ? 'user-profile' : 'join-sign-in';

    this.$router.push({ name });
  }

  /** Redirect user to next route, depends on current state of user */
  newOrder() {
    /** shortcut to go to next location */
    const next = name => this.$router.push({ name });

    // if restaurant doesn't selected - go to select restaurant
    if (!this.restaurantId) {
      return next('new-order-select-location');
    }

    // go to menu
    return next('menu');
  }
}
</script>

<style lang="scss" module>
@import "~@/style/helpers.scss";
@import "~@/style/variables.scss";

.main {
  box-sizing: border-box;
  padding: 18px $mobile-content-side-padding 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &Header {
    display: flex;
    justify-content: flex-end;
  }


  &Logo {
    height: 203px;
    width: 203px;
    margin: -5px auto 0;
    display: block;
  }
}

.hr {
  box-sizing: border-box;
  height: 5px;
  width: 100%;
  max-width: 130px;
  background-color: $green2;
  margin: 35px auto 15px;
}

.text {
  max-width: 186px;
  font-size: rem(15px);
  font-weight: 300;
  letter-spacing: -0.21px;
  text-align: center;
  margin: auto;
}

.welcomText {
  color: $black-semi-transparent;
  font-family: $decor-font-family;
  font-size: rem(24px);
  letter-spacing: rem(0.67px);
  text-align: center;
  margin-top: 24px;
}

.link {
  color: $links-color;
  font-size: rem(13px);
  font-weight: 300;
  text-align: center;
  display: inline-block;
  margin: 5px 0 0 0;
  text-decoration: none;
}

.userButton {
  margin: 0;
}

.btnGroup {
  margin: 17px auto 15px;
  max-width: 240px;
}

.tryOur {
  @include background-2x(
    '/assets/img/mibile-main-bottom-bg',
    'png',
    auto, auto,
    center,
    no-repeat);
  background-size: cover;
  padding: 20px $mobile-content-side-padding;
  margin-left: -$mobile-content-side-padding;
  margin-right: -$mobile-content-side-padding;

  &Content {
    max-width: 290px;
    margin: auto;
  }

  &Title {
    color: $white;
    font-family: $main-font-family;
    font-size: 1rem;
    letter-spacing: rem(-0.36px);
    text-transform: uppercase;
    margin-bottom: 5px;
  }

  &Text {
    color: $white;
    font-family: $side-font-family;
    font-weight: 700;
    font-size: rem(17px);
    letter-spacing: rem(-0.1px);
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileMain.vue